import * as CL from '@design-system/component-library';

import './TrackingCodes.scss';

const trackingCodeToUrl = (trackingCode: string) => {
  if (trackingCode.match(/^JJFI/)) {
    return `https://www.posti.fi/henkiloasiakkaat/seuranta/#/lahetys/${trackingCode}`;
  } else if (trackingCode.match(/^(3733|MA|MH)/)) {
    return `https://www.matkahuolto.fi/seuranta?parcelNumber=${trackingCode}`;
  } else {
    return undefined;
  }
};

interface TrackingCodeProps {
  trackingCode: string;
}

const TrackingCodeLinkOrText = ({ trackingCode }: TrackingCodeProps) => {
  const href = trackingCodeToUrl(trackingCode);

  if (href) {
    return (
      <CL.Link linkTarget="_blank" linkHref={href} rel="noreferrer">
        {trackingCode} <CL.Icon icon="external-link" />
      </CL.Link>
    );
  } else {
    return <>{trackingCode}</>;
  }
};

interface TrackingCodesProps {
  trackingCodes: string[];
}

export const TrackingCodes = ({ trackingCodes }: TrackingCodesProps) => {
  return (
    <ul className="of-tracking-codes">
      {trackingCodes.map(e => (
        <li key={e}>
          <TrackingCodeLinkOrText trackingCode={e} />
        </li>
      ))}
    </ul>
  );
};
